import Cookies from "js-cookie";

/**
 * @description Custom converter for js-cookie to use encodeURIComponent when encoding the cookie value
 */

export function encodedCookies() {
  return Cookies.withConverter({
    write(value) {
      return encodeURIComponent(value);
    },
    read(value) {
      return decodeURIComponent(value);
    },
  });
}
